import { Condition } from '../Condition';
import AdClickEventProperty from './AdClickEventProperty';
import AdImpressionEventProperty from './AdImpressionEventProperty';
import ConditionProperty from './ConditionProperty';
import ContextProperty from './ContextProperty';
import ErrorEventProperty from './ErrorEventProperty';
import EventTypeProperty from './EventTypeProperty';
import FrontendContextProperty from './FrontendContextProperty';
import LinkClickEventProperty from './LinkClickEventProperty';
import PageElement from './PageElement';
import StructuredEventProperty from './StructuredEventProperty';
import UnstructuredEventDataProperty from './UnstructuredEventDataProperty';
import UnstructuredEventNameProperty from './UnstructuredEventNameProperty';
import WindowProperty from './WindowProperty';

export default class ConditionTypeFactory {
  public static readonly TYPES = [
    ContextProperty.type,
    EventTypeProperty.type,
    StructuredEventProperty.type,
    AdClickEventProperty.type,
    AdImpressionEventProperty.type,
    ErrorEventProperty.type,
    LinkClickEventProperty.type,
    UnstructuredEventNameProperty.type,
    UnstructuredEventDataProperty.type,
    WindowProperty.type,
    PageElement.type,
    FrontendContextProperty.type,
  ];

  static create(condition: Condition): ConditionProperty {
    switch (condition.type) {
      case ContextProperty.type:
        return new ContextProperty(condition);
      case EventTypeProperty.type:
        return new EventTypeProperty(condition);
      case StructuredEventProperty.type:
        return new StructuredEventProperty(condition);
      case UnstructuredEventDataProperty.type:
        return new UnstructuredEventDataProperty(condition);
      case UnstructuredEventNameProperty.type:
        return new UnstructuredEventNameProperty(condition);
      case WindowProperty.type:
        return new WindowProperty(condition);
      case AdClickEventProperty.type:
        return new AdClickEventProperty(condition);
      case AdImpressionEventProperty.type:
        return new AdImpressionEventProperty(condition);
      case ErrorEventProperty.type:
        return new ErrorEventProperty(condition);
      case LinkClickEventProperty.type:
        return new LinkClickEventProperty(condition);
      case PageElement.type:
        return new PageElement(condition);
      case FrontendContextProperty.type:
        return new FrontendContextProperty(condition);
      default:
        throw new Error('Unexpected condition property passed: ' + condition.type);
    }
  }

  static getAll(): ConditionProperty[] {
    return this.TYPES.map(type => this.create({type} as Condition));
  }
}
